<template>
  <div>
    <v-clamp autoresize :max-lines="2" class="title" :class="colorClass">
      {{ title }}
    </v-clamp>
    <v-clamp
      autoresize
      :max-lines="descriptionMaxLines"
      class="description"
      :class="colorClass"
    >
      {{ description }}
    </v-clamp>
  </div>
</template>

<script>
import Vue from 'vue';
import VClamp from 'vue-clamp';

export default Vue.extend({
  name: 'SocialMarketingStudioImageContent',
  props: {
    colorType: {
      type: String,
      required: false,
    },
    title: {
      type: String,
      required: false,
    },
    description: {
      type: String,
      required: false,
    },
    descriptionMaxLines: {
      type: Number,
      required: false,
      default: 3,
    },
  },
  components: {
    VClamp,
  },
  computed: {
    colorClass() {
      if (this.colorType === 'light') {
        return 'c-white';
      } else if (this.colorType === 'dark-opacity') {
        return 'c-dark-opacity';
      }
      return '';
    },
  },
});
</script>

<style lang="scss" scoped>
@import '@/web/styles/components-variables.scss';

.title {
  font-size: 16px * $social-marketing-card-factor;
  color: $charcoal;
}

.description {
  display: block;
  font-size: 12px * $social-marketing-card-factor;
  color: $charcoal;
  margin-top: 7px * $social-marketing-card-factor;
  word-wrap: break-word;
}

.c-dark-opacity {
  color: rgba($charcoal, 0.5);
}
</style>
